import { render, staticRenderFns } from "./CollectionsListing.vue?vue&type=template&id=1462acc9&scoped=true"
import script from "./CollectionsListing.vue?vue&type=script&lang=js"
export * from "./CollectionsListing.vue?vue&type=script&lang=js"
import style0 from "./CollectionsListing.vue?vue&type=style&index=0&id=1462acc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1462acc9",
  null
  
)

export default component.exports